// extracted by mini-css-extract-plugin
export default {"infoBoxContainer":"UploadDocumentsPage__infoBoxContainer-DgIw","pageLoader":"UploadDocumentsPage__pageLoader-Suqo"};